import React from 'react';

export default function IcX() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
        viewBox="0 0 9 9" >
      <g>
        <g id="Combined-Shape">
          <path d="M8.8,0.2c0.3,0.3,0.3,0.7,0,1L5.5,4.5l3.3,3.3c0.3,0.3,0.3,0.7,0,1C8.7,8.9,8.5,9,8.3,9C8.1,9,7.9,8.9,7.8,8.8L4.5,5.5
            L1.2,8.8C1.1,8.9,0.9,9,0.7,9C0.5,9,0.3,8.9,0.2,8.8c-0.3-0.3-0.3-0.7,0-1l3.3-3.3L0.2,1.2c-0.3-0.3-0.3-0.7,0-1s0.7-0.3,1,0
            l3.3,3.3l3.3-3.3C8-0.1,8.5-0.1,8.8,0.2z"/>
        </g>
      </g>
    </svg>
  );
}
